import posthog from "posthog-js";

// Initialize PostHog only in production environment
if (process.env.REACT_APP_NODE_ENV !== 'Dev') {
  const recordingEnabled = process.env.REACT_APP_POSTHOG_RECORDING_ENABLED === 'true';
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    capture_pageview: false,
    disable_session_recording: !recordingEnabled,
    cookieless_mode: 'on_reject',
  });

  posthog.opt_in_capturing(); // Default to opt-in; will be changed based on user consent
}

// Expose the initialized PostHog instance on the window object for global access
if (typeof window !== 'undefined') {
  window.posthog = posthog;

  window.tb2_posthog_consent = {
    acceptAnalytics() {
      posthog.opt_in_capturing();
      posthog.set_config({ persistence: 'localStorage+cookie' });
      posthog.reloadFeatureFlags(); // Reload feature flags to reflect opt-in
    },
    rejectAnalytics() {
      posthog.opt_out_capturing();
      posthog.set_config({ persistence: 'memory' }); // Clear persistent data
      posthog.reloadFeatureFlags(); // Reload feature flags to reflect opt-out
    }
  }
}

export default posthog;
